@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

.csw-package-dropdown-toggler {
  &:disabled {
    background-color: var(--number-input--disabled--background-color);
    color: var(--default--icon--fill-color--12);
    border: 1px solid var(--default--dropdown--border-color--1);
    opacity: 1;

    &:hover {
      background-color: var(--number-input--disabled--background-color);
    }
  }

  &.smart-fill {
    border: 0 solid transparent;
    background: @ship-ai--input--background-color;
    border-radius: 3px;
  }
}

.package-type-with-link {
  align-items: center;
  justify-content: space-between;
}
